import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  isLoading = false,
  leftIcon,
  rightIcon,
  className = '',
  disabled,
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#1C274C] text-white hover:bg-[#2a3a6b] focus:ring-[#1C274C]',
    secondary: 'bg-[#FC963E] text-white hover:bg-[#e8873a] focus:ring-[#FC963E]',
    outline: 'border-2 border-[#1C274C] text-[#1C274C] hover:bg-[#1C274C] hover:text-white focus:ring-[#1C274C]',
    ghost: 'text-[#1C274C] hover:bg-gray-100 focus:ring-gray-200'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: disabled || isLoading ? 1 : 1.02
  }} whileTap={{
    scale: disabled || isLoading ? 1 : 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-205">
      {isLoading && <Loader2 className="w-4 h-4 mr-2 animate-spin" data-id="element-206" />}
      {!isLoading && leftIcon && <span className="mr-2" data-id="element-207">{leftIcon}</span>}
      {children}
      {!isLoading && rightIcon && <span className="ml-2" data-id="element-208">{rightIcon}</span>}
    </motion.button>;
};